console.log('ship-ins.js has loaded');

var Shopify = Shopify || {};
// Use the handle from your configured shipping insurance product:
var SHIP_PROD_HANDLE = SHIP_PROD_HANDLE || ship_ins.product.handle;
const SHIP_PROD_TYPE = 'Shipping-Insurance';
// Convert the excluded products setting into an array:
const EXCLUDED_PRODUCTS = ('burn-rate-diet,the-dolce-diet-option-3,the-dolce-diet-option-2').split(',');

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') { 
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);
  
  function defaultOption(opt, def) {
    return (typeof opt === 'undefined' ? def : opt);
  }
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
  
    if (isNaN(number) || number == null) { 
      return 0; 
    }
  
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  
  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  
  return formatString.replace(placeholderRegex, value);
};

var _utils = _utils || {
  async getCart() {
    return await fetch('/cart.js?delivery_internal=true')
      .then(response => response.json())
      .then(cart => cart);
  },
  
  formatMoney(value) {
    return `${Shopify.formatMoney(value, Shopify.money_format)} ${Shopify.currency.active}`;
  },

  // Retrieves the appropriate shipping insurance variant based on the cart total.
  getShipVariant(cart) {
    var product = ship_ins.product;
    var variant = product.variants[0];
    
    function getVariant(cart) {
      // Filter out cart items based on product.handle and EXCLUDED_PRODUCTS.
      // IMPORTANT: Use the nested product handle in the new theme.
      var cart_items = cart.items.filter(item =>
        item.product.handle !== SHIP_PROD_HANDLE &&
        EXCLUDED_PRODUCTS.indexOf(item.product.handle) === -1
      );
      // Sum the final line prices (which are in cents)
      var cart_total_price = cart_items.reduce((sum, item) => sum + item.final_line_price, 0);
      console.log('Cart total price (in cents):', cart_total_price);
      
      // Note: thresholds are now in cents (e.g. 750 means $7.50)
      if (cart_total_price < 750) {
        variant = null;
      } else if (cart_total_price >= 750 && cart_total_price < 7500) {
        variant = product.variants[0];
      } else if (cart_total_price >= 7500 && cart_total_price < 12500) {
        variant = product.variants[1];
      } else {
        variant = product.variants[2];
      }
      console.log('Selected insurance variant:', variant);
      return variant;
    }
    
    if (!cart) {
      // If no cart data is passed, fetch it first.
      return new Promise((resolve) => {
        _utils.getCart().then(cartData => {
          resolve(getVariant(cartData));
        });
      });
    } else {
      return getVariant(cart);
    }
  },
  
  getInterval(optionValue) {
    const intervalUnits = ['day', 'week', 'month', 'year'];
    const response = {
      frequency: 1,
      unit: 'day'
    };
      
    let frequency = optionValue.toLowerCase().match(/\d+/g);
    if (frequency != null) response.frequency = frequency[0];
  
    for (const index in intervalUnits) {
      const unit = intervalUnits[index];
      const regex = new RegExp(unit, 'g');
      if (optionValue.toLowerCase().match(regex)) {
        response.unit = unit;
        break;
      }
    }
    if (response.frequency > 1) response.unit += 's';
    return response;
  },
  
  getEligibleSellingPlan(product, selectedVariant, interval, intervalCount) {
    if (!product.selling_plan_groups || !interval || !intervalCount) return false;
    const skioSellingPlanGroups = product.selling_plan_groups;
    const availableSellingPlanGroups = skioSellingPlanGroups.filter(selling_plan_group =>
      selling_plan_group.selling_plans.some(selling_plan =>
        selectedVariant.selling_plan_allocations.some(
          selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
        )
      )
    );
    if (!availableSellingPlanGroups.length) return false;
    return availableSellingPlanGroups
      .flatMap(group => group.selling_plans)
      .find(selling_plan => {
        const intervalOptions = _utils.getInterval(selling_plan?.options?.[1]?.value);
        return intervalOptions.unit === interval.toLowerCase() && intervalOptions.frequency == intervalCount;
      });
  }
};

class InsuranceToggle extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type=checkbox]');
    if (this.checkbox) {
      this.checkbox.addEventListener('change', (evt) => {
        document.dispatchEvent(new CustomEvent('insuranceChange', { detail: { checked: evt.currentTarget.checked } }));
      });
    }
  }
  
  connectedCallback() {
    // Ensure the checkbox element is set when the component is connected.
    this.checkbox = this.querySelector('input[type=checkbox]');
  }
}

customElements.define('insurance-toggle', InsuranceToggle);

function checkShipIns() {
  // Get the current cart state (assumes your global liquidAjaxCart.cart is available)
  const cart = window.liquidAjaxCart.cart;
  console.log('Cart object:', cart);
  const requests = [];
  
  // Retrieve the insurance variant based on the cart total.
  let ins_variant = _utils.getShipVariant(cart);
  
  // Check for insurance items already in the cart (using item.product.type).
  const item_ship_ins = cart.items.reduce((acc, item) => {
    if (item.product && item.product.type === SHIP_PROD_TYPE) return [...acc, item];
    return acc;
  }, []);
  console.log('Existing insurance items:', item_ship_ins);
  
  // Check if every item is digital or should be excluded.
  const onlyDigitalItems = cart.items.every((item) => {
    return item.gift_card ||
           !item.product.requires_shipping ||
           item.product.handle === SHIP_PROD_HANDLE ||
           EXCLUDED_PRODUCTS.indexOf(item.product.handle) !== -1;
  });
  console.log('onlyDigitalItems:', onlyDigitalItems);
  
  let items_not_ins = cart.items.filter(item => item.product.type !== SHIP_PROD_TYPE);
  if (onlyDigitalItems || !cart.requires_shipping || !items_not_ins) {
    ship_ins_enabled = false;
    ins_variant = null;
  } else {
    ship_ins_enabled = true;
  }
  console.log('ship_ins_enabled:', ship_ins_enabled);
  
  let selling_plan_id = null;
  let items_subscription = items_not_ins.find(item => item.selling_plan_allocation !== undefined);
  if (items_subscription && ins_variant) {
    let interval = _utils.getInterval(items_subscription.selling_plan_allocation.selling_plan?.options?.[1]?.value);
    if (interval) {
      let selling_plan = _utils.getEligibleSellingPlan(ship_ins.product, ins_variant, interval.unit, interval.frequency);
      if (selling_plan) {
        selling_plan_id = selling_plan.id;
      }
    }
  }
  console.log('Selling plan ID:', selling_plan_id);
  
  // Update the insurance UI – toggle visibility and update the displayed price.
  const $ship_variant_price = [...document.querySelectorAll('[data-ship-variant-price]')];
  $ship_variant_price.forEach((item) => {
    let $ship_ins_wrap = item.closest('.ship-insurance-wrap');
    if (!ins_variant) {
      $ship_ins_wrap.classList.add('hidden');
    } else {
      item.innerText = _utils.formatMoney(ins_variant.price);
      $ship_ins_wrap.classList.remove('hidden');
    }
  });
  
  const session_ins_disabled = JSON.parse(sessionStorage.getItem('ship-ins-declined')) || false;
  if (ship_ins?.enabled === true && ship_ins_enabled) {
    $('.ship-insurance-wrap').removeClass('hidden');
  } else {
    $('.ship-insurance-wrap').addClass('hidden');
  }
  
  // Auto-add or update the shipping insurance line item if needed.
  if (ins_variant?.id && ship_ins_enabled && session_ins_disabled !== true) {
    const promoVariantLineItem = cart.items.find(lineItem => lineItem.variant_id === ins_variant.id);
    const switchSellingPlan = promoVariantLineItem && selling_plan_id !== promoVariantLineItem.selling_plan_allocation?.selling_plan?.id;
    if (!promoVariantLineItem) {
      requests.push({
        type: "add",
        body: {
          items: [{
            id: ins_variant.id,
            quantity: 1,
            selling_plan: selling_plan_id,
            properties: {}
          }]
        }
      });
    } else if (switchSellingPlan) {
      requests.push({
        type: "change",
        body: {
          id: promoVariantLineItem.key,
          selling_plan: selling_plan_id
        }
      });
    } else if (promoVariantLineItem.quantity > 1) {
      requests.push({
        type: "update",
        body: {
          updates: {
            [promoVariantLineItem.key]: 1
          }
        }
      });
    }
  }
  
  if (item_ship_ins.length) {
    const updates = item_ship_ins.reduce((acc, item) => {
      if ((ins_variant && ins_variant.id != item.id) || !ins_variant || !ship_ins_enabled || session_ins_disabled === true) {
        return { ...acc, [item.key]: 0 };
      }
      return acc;
    }, {});
    if (Object.keys(updates).length) {
      requests.push({
        type: "update",
        body: { updates }
      });
    }
  }
  if (!requests.length) return;
  console.log('Insurance requests queued:', requests);
  return { requests };
}

async function cartReload() {
  const cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
  const cartItems = document.querySelector('cart-items');
  if (cartEl) {
    cartEl.style.setProperty('pointer-events', 'none');
    cartEl.classList.add('loading');
  }
  if (cartEl || (isCartPage && cartItems)) {
    if (cartEl) {
      cartEl.setActiveElement(document.activeElement);
    }
    const sections = cartEl ? cartEl.getSectionsToRender().map(section => section.id) : [];
    if (isCartPage && cartItems) {
      const cart_sections = cartItems.getSectionsToRender().map(section => section.section);
      sections.push(...cart_sections);
    }
    const body = JSON.stringify({
      updates: {},
      sections,
      sections_url: window.location.pathname,
    });
    await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
      .then(response => response.json())
      .then(state => {
        const parsedState = state;
        cartEl.dispatchEvent(new CustomEvent('renderContents', { detail: parsedState }));
        if (isCartPage && cartItems) {
          cartItems.dispatchEvent(new CustomEvent('renderContents', { detail: parsedState }));
        }
      })
      .catch(() => {
        if (cartEl) {
          cartEl.style.removeProperty('pointer-events');
          cartEl.classList.remove('loading');
        }
      })
      .finally(() => {
        if (cartEl) {
          cartEl.style.removeProperty('pointer-events');
          cartEl.classList.remove('loading');
        }
      });
  }
  
  const cart = window.liquidAjaxCart.cart;
  let ins_variant = _utils.getShipVariant(cart);
  
  const onlyDigitalItems = cart.items.every(item => {
    return item.gift_card ||
      !item.product.requires_shipping ||
      item.product.handle === SHIP_PROD_HANDLE ||
      EXCLUDED_PRODUCTS.indexOf(item.product.handle) !== -1;
  });
  
  let items_not_ins = cart.items.filter(item => item.product.type !== SHIP_PROD_TYPE);
  if (onlyDigitalItems || !cart.requires_shipping || !items_not_ins) {
    ship_ins_enabled = false;
    ins_variant = null;
  } else {
    ship_ins_enabled = true;
  }
  
  const $ship_variant_price = [...document.querySelectorAll('[data-ship-variant-price]')];
  $ship_variant_price.forEach(item => {
    let $ship_ins_wrap = item.closest('.ship-insurance-wrap');
    if (!ins_variant) {
      $ship_ins_wrap.classList.add('hidden');
    } else {
      item.innerText = _utils.formatMoney(ins_variant.price);
      $ship_ins_wrap.classList.remove('hidden');
    }
  });
  
  if (ship_ins?.enabled === true && ship_ins_enabled) {
    $('.ship-insurance-wrap').removeClass('hidden');
  } else {
    $('.ship-insurance-wrap').addClass('hidden');
  }
  return;
}

function getLiquidAjaxCart() {
  if (window.liquidAjaxCart?.init) {
    window.liquidAjaxCart.get();
  }
}

document.addEventListener("liquid-ajax-cart:request-start", () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.style.setProperty('pointer-events', 'none');
    cartDrawer.classList.add('loading');
  }
});
document.addEventListener("liquid-ajax-cart:request-end", () => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.style.removeProperty('pointer-events');
    cartDrawer.classList.remove('loading');
  }
});

document.addEventListener("liquid-ajax-cart:init", () => {
  window.liquidAjaxCart.conf('mutations', [ checkShipIns, cartReload ]);
  const events = 'cart:notification-open theme:product:added theme:cart:updated';
  events.split(' ').forEach(evt => {
    document.addEventListener(evt, () => {
      getLiquidAjaxCart();
    });
  });
  document.addEventListener('insuranceChange', evt => {
    var isChecked = evt.detail?.checked;
    if (!isChecked) {
      localStorage.setItem("cart_has_ins", "false");
      sessionStorage.setItem('ship-ins-declined', !isChecked);
    } else {
      sessionStorage.removeItem('ship-ins-declined');
    }
    getLiquidAjaxCart();
  });
});
